import React, { useEffect } from 'react';
import { useLazyGetSocialMediaOfBrandForCloudCampaignQuery } from '../../store/api/social-media.api';
import { useAppSelector } from '../../store/store';
import { getActiveBrand } from '../../store/selector/brand.selector';
import { getOrganizationId } from '../../store/selector/organization.selector';
import { Spinner } from 'react-bootstrap';
import PublishSocialAccount from './PublishSocialAccount';
import { ICCSocialMedia } from '../../interfaces/social-media.interface';

interface IProps {
    selectedAccounts: ICCSocialMedia[];
    setSelectedAccounts: React.Dispatch<React.SetStateAction<ICCSocialMedia[]>>;
}

const PublishSocialMedia = ({ selectedAccounts, setSelectedAccounts }: IProps) => {
    const activeBrand = useAppSelector(getActiveBrand);
    const organizationId = useAppSelector(getOrganizationId);
    const [getSocialMediaOfBrandForCloudCampaign, { data: accounts, isFetching }] =
        useLazyGetSocialMediaOfBrandForCloudCampaignQuery();

    useEffect(() => {
        const fetchAccounts = async () => {
            if (activeBrand && organizationId) {
                await getSocialMediaOfBrandForCloudCampaign({
                    brandId: activeBrand.id,
                    organizationId,
                });
            }
        };

        fetchAccounts();
    }, [activeBrand, organizationId]);

    return (
        <div className="tw-w-[390px] tw-p-6 tw-border-[2px] tw-rounded-md tw-border-gray-250 tw-drop-shadow-[0_2px_4px_-2px_rgba(0,0,0,0.1)] tw-drop-shadow-[0_4px_6px_-1px_rgba(0,0,0,0.1)]">
            <div className="tw-w-full text-center tw-font-semibold tw-text-lg">Which accounts?</div>
            <div className="tw-mb-4 tw-mt-[44px] tw-w-full">
                {isFetching ? (
                    <div className="tw-w-full tw-flex tw-flex-col tw-items-center tw-mt-5">
                        <Spinner className="tw-text-purple-500" />
                    </div>
                ) : (
                    <div className="tw-w-full tw-max-h-[230px] tw-overflow-y-auto tw-flex tw-flex-col tw-gap-y-2">
                        {accounts &&
                            accounts.map((account, index) => (
                                <PublishSocialAccount
                                    account={account}
                                    key={index}
                                    selectedAccounts={selectedAccounts}
                                    setSelectedAccounts={setSelectedAccounts}
                                />
                            ))}
                    </div>
                )}
            </div>
        </div>
    );
};

export default PublishSocialMedia;
